var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person_center_cla" },
    [
      _c(
        "div",
        { staticClass: "center-card-cla" },
        [
          _c("div", { staticClass: "info_title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("center.basicInfo")) + "\n    ")
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "user-info-box" }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "center-info-item" },
                [
                  _c("lable", { staticClass: "center-lable-cla" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("center.nickName")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "center-info-value-cla" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: this.$t("center.plaContent") },
                        on: { change: _vm.onInputChange },
                        model: {
                          value: _vm.userInfo.nickName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userInfo,
                              "nickName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "userInfo.nickName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info-item" },
                [
                  _c("lable", { staticClass: "center-lable-cla" }, [
                    _vm._v(_vm._s(_vm.$t("center.account")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "center-info-value-cla" }, [
                    _vm._v(_vm._s(_vm.userInfo.loginName))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "red" },
                      attrs: { type: "text" },
                      on: { click: _vm.cancelAccount }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("cancelAccount.cancelAccount"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info-item" },
                [
                  _c("lable", { staticClass: "center-lable-cla" }, [
                    _vm._v(_vm._s(_vm.$t("center.email")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "center-info-value-cla" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.userInfo.emailState === 0
                            ? this.$t("center.noBindEmail")
                            : _vm.userInfo.email
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "update_cla",
                      on: {
                        click: function($event) {
                          return _vm.bindOrUpdateEamil()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.userInfo.emailState === 0
                              ? this.$t("center.bindEmail")
                              : this.$t("center.updateEamil")
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info-item" },
                [
                  _c("lable", { staticClass: "center-lable-cla" }, [
                    _vm._v(_vm._s(_vm.$t("center.phone")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "center-info-value-cla" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.userInfo.phoneState === 0
                            ? this.$t("center.noBindPhone")
                            : _vm.userInfo.prefix + _vm.userInfo.phone
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "update_cla",
                      on: {
                        click: function($event) {
                          return _vm.bindOrUpdatePhone()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.userInfo.phoneState === 0
                              ? this.$t("center.bindPhone")
                              : this.$t("center.updatePhone")
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info-item" },
                [
                  _c("lable", { staticClass: "center-lable-cla" }, [
                    _vm._v(_vm._s(_vm.$t("center.password")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "center-info-value-cla" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.userInfo.password) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "update_cla",
                      on: {
                        click: function($event) {
                          return _vm.updatePassword()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("center.updatePassword")))]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "avatar-uploader",
                    attrs: {
                      action: "/apiv1/account/uploadHeadImg",
                      data: _vm.imgData,
                      "show-file-list": false,
                      "on-success": _vm.handleAvatarSuccess,
                      "before-upload": _vm.beforeAvatarUpload
                    }
                  },
                  [
                    _vm.userInfo.headImg
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.userInfo.headImg }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-header-img-cla" }, [
                      _c("i", { staticClass: "el-icon-edit" })
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-divider", { staticClass: "line-cla" }),
          _vm._v(" "),
          _c("div", { staticClass: "socialAccount-cla info_title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("center.socialAccount")) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "center-info-item" },
            [
              _c("lable", { staticClass: "center-lable-cla" }, [
                _vm._v(_vm._s(_vm.$t("center.wetchat")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info-value-cla" },
                [
                  _vm.userInfo.weChatState === 0
                    ? _c("img", {
                        staticStyle: {
                          width: "32px",
                          height: "32px",
                          "vertical-align": "middle"
                        },
                        attrs: { src: require("@/assets/login/wetchat_1.png") }
                      })
                    : _c("img", {
                        staticStyle: {
                          width: "32px",
                          height: "32px",
                          "vertical-align": "middle"
                        },
                        attrs: { src: require("@/assets/login/wetchat_2.png") }
                      }),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      attrs: { placement: "right", trigger: "manual" },
                      model: {
                        value: _vm.showQrCode,
                        callback: function($$v) {
                          _vm.showQrCode = $$v
                        },
                        expression: "showQrCode"
                      }
                    },
                    [
                      !_vm.showOrHidden
                        ? _c("div", { staticClass: "wx-log-box-cla" }, [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  staticStyle: {
                                    "font-size": "14px",
                                    cursor: "pointer"
                                  },
                                  on: { click: _vm.closeQr }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "border-item-cla1" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "border-item-cla2" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "border-item-cla3" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "border-item-cla4" }),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                width: "33.33rem",
                                height: "26.33rem",
                                display: "flex",
                                "justify-content": "center"
                              },
                              attrs: { id: "id_qrCode" }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo.weChatState === 0
                        ? _c(
                            "span",
                            {
                              staticStyle: { color: "#ccc" },
                              attrs: { slot: "reference" },
                              slot: "reference"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("center.nobindWetchat")) +
                                  "\n            "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "update_cla",
                                  on: {
                                    click: function($event) {
                                      return _vm.bindWx()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("center.bindWetchat"))
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "update_cla",
                              attrs: { slot: "reference" },
                              on: {
                                click: function($event) {
                                  return _vm.unbindWx()
                                }
                              },
                              slot: "reference"
                            },
                            [_vm._v(_vm._s(_vm.$t("center.updateWetchat")))]
                          )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider", { staticClass: "line-cla" }),
          _vm._v(" "),
          _c("div", { staticClass: "socialAccount-cla info_title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("cancelAccount.agreements")) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("span", [
                _vm._v(" " + _vm._s(_vm.$t("cancelAccount.developer")))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.showAgreementDia("developer")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancelAccount.view")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("cancelAccount.privacyPolicy")) + " ")
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.showAgreementDia("privacyPolicy")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancelAccount.view")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("cancelAccount.dataProcess")) + " ")
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.showAgreementDia("dataProcess")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancelAccount.view")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("zk-modify-pwd", {
        attrs: {
          appendBody: false,
          dialogVisible: _vm.dialogVisible,
          redirectLogin: true
        },
        on: {
          close: function($event) {
            _vm.dialogVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "emailDialog",
        _vm._b(
          {
            ref: "emailDialog",
            on: { closeEmail: _vm.closeEmail, submitEmail: _vm.submitEmail }
          },
          "emailDialog",
          _vm.emailProp,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "phoneDialog",
        _vm._b(
          {
            ref: "phoneDialog",
            on: { closePhone: _vm.closePhone, submitPhone: _vm.submitPhone }
          },
          "phoneDialog",
          _vm.phoneProp,
          false
        )
      ),
      _vm._v(" "),
      _c("cancleAccount", {
        ref: "cancleAccount",
        attrs: { userInfo: _vm.results }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d027929", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d027929","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/personCenter/center.vue
// module id = null
// module chunks = 